export default __webpack_public_path__ + "static/media/wompi_icon.3fbc50f2.svg";